import { CountUp } from 'countup.js';

export default {

	init() {
		console.log('init stats...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	// Set up all standard sliders
	bindEvents() {
		const elemSelector = '.use-countupjs .card.card-stat .is-stat span.stat-content';
		var elems = document.querySelectorAll(elemSelector);

		if (elems.length) {
			let countUpElems = [];
			elems.forEach(function(elem, index) {
				console.log(elem);
				countUpElems[index] = {
					started: false,
					obj: new CountUp(elem, elem.innerHTML, {duration: 4})
				};
			});
	
			$(window).on('scroll', function(){
				$.each(elems, function(index){
					if(!countUpElems[index].started) {
						const inView = Stats.isInView($(this));
						if(inView && !countUpElems[index].started) {
							countUpElems[index].started = true;
							countUpElems[index].obj.start();
							console.log(countUpElems);
						}
					}
				});
			});
		}
	},

	isInView(element) {
	    let windowBottom = $(window).scrollTop() + window.innerHeight;
	    let eTop = element.offset().top;

	    return eTop < windowBottom;
	}

};